<div *ngIf="translationKey">
  <div class="notification-banner">
    {{ translationKey | translate: translationParams | ucfirst }}
  </div>
</div>
